export var StringMatchOption;
(function (StringMatchOption) {
    StringMatchOption[StringMatchOption["StartsWith"] = 0] = "StartsWith";
    StringMatchOption[StringMatchOption["ExactMatch"] = 1] = "ExactMatch";
})(StringMatchOption || (StringMatchOption = {}));
export var ChangedItemType;
(function (ChangedItemType) {
    ChangedItemType[ChangedItemType["Unknown"] = 0] = "Unknown";
    ChangedItemType[ChangedItemType["Term"] = 1] = "Term";
    ChangedItemType[ChangedItemType["TermSet"] = 2] = "TermSet";
    ChangedItemType[ChangedItemType["Group"] = 3] = "Group";
    ChangedItemType[ChangedItemType["TermStore"] = 4] = "TermStore";
    ChangedItemType[ChangedItemType["Site"] = 5] = "Site";
})(ChangedItemType || (ChangedItemType = {}));
export var ChangedOperationType;
(function (ChangedOperationType) {
    ChangedOperationType[ChangedOperationType["Unknown"] = 0] = "Unknown";
    ChangedOperationType[ChangedOperationType["Add"] = 1] = "Add";
    ChangedOperationType[ChangedOperationType["Edit"] = 2] = "Edit";
    ChangedOperationType[ChangedOperationType["DeleteObject"] = 3] = "DeleteObject";
    ChangedOperationType[ChangedOperationType["Move"] = 4] = "Move";
    ChangedOperationType[ChangedOperationType["Copy"] = 5] = "Copy";
    ChangedOperationType[ChangedOperationType["PathChange"] = 6] = "PathChange";
    ChangedOperationType[ChangedOperationType["Merge"] = 7] = "Merge";
    ChangedOperationType[ChangedOperationType["ImportObject"] = 8] = "ImportObject";
    ChangedOperationType[ChangedOperationType["Restore"] = 9] = "Restore";
})(ChangedOperationType || (ChangedOperationType = {}));
//# sourceMappingURL=types.js.map